import { Component, Inject, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import * as AOS from 'aos';
import { Constants } from '../../common/constants';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { SeoService } from 'src/app/common/seo.service';

@Component({
  selector: 'app-ouropinion-casestudy',
  templateUrl: './ouropinion-casestudy.component.html',
  styleUrls: ['./ouropinion-casestudy.component.css']
})
export class OuropinionCasestudyComponent implements OnInit {
    baseUrl=Constants.baseUrl;
    isBrowser:boolean=false;
    isOpen: boolean[] = [];
  constructor(
    private titleService: Title,    @Inject(PLATFORM_ID) private platformId: any,
    private _renderer2: Renderer2,private seoService:SeoService,
    @Inject(DOCUMENT) private _document: Document,
    private metaService: Meta
  ) {this.isBrowser=isPlatformBrowser(this.platformId);
    this.isOpen = new Array(this.accordionItems.length).fill(false);
}
ngOnInit(): void {  
  let script = this._renderer2.createElement('script');
  script.type = `application/ld+json`;
  script.text = `
  {
    "@context": "https://schema.org",
    "@type": "Article",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "https://mitresource.com/ouropinion-casestudy/"
    },
    "headline": "Opinion polling made seamless",
    "description": "Learn how we built a global website, with minimal downtime, with future cloud advances incorporated into client's IT infrastructure.",
    "image": "https://mitresource.com/assets/images/banners/ouropinion_mobilebannar.png",  
    "author": {
      "@type": "Organization",
      "name": "Maganti IT Resources",
      "url": "https://mitresource.com/"
    },  
    "publisher": {
      "@type": "Organization",
      "name": "Maganti IT",
      "logo": {
        "@type": "ImageObject",
        "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
      }
    },
    "datePublished": "2023-06-15"
  }`;
  
  this._renderer2.appendChild(this._document.head, script);
this.setTitleAndMetaTags();
this.seoService.createLinkForCanonicalURL();
 if(this.isBrowser){     
    AOS.init({disable: 'mobile', duration: 2000, delay: 500,});   
} 
}




  private setTitleAndMetaTags(): void {
    this.titleService.setTitle('Helping shape social Perspectives');

    this.metaService.addTags([
      { name: 'description', content: 'In a consumer-first demographic world, opinion polling helps understand public perceptions and behaviors toward broad-ranging issues!' },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: 'Helping shape social Perspectives' },
      { property: 'og:url', content: 'https://mitresource.com/ouropinion-casestudy/' },
      { property: 'og:image', content: 'https://mitresource.com/assets/images/ouropinionsimages/clientbenifits.png' },
      { property: 'og:description', content: 'In a consumer-first demographic world, opinion polling helps understand public perceptions and behaviors toward broad-ranging issues.' },
    ]);
  }
 
  accordionItems = [
    {
      title: 'Enhanced Value',
      content: 'This solution helped the client to outsource their application development and infrastructure management to MIT resources while keeping governance with them, so that they can concentrate to their core business.'
    },
    {
      title: 'Highly Scalable',
      content:'The client now has full control over its configurations through its highly available, secure, and compliant environments.'
    },
    {
      title: 'Improved Performance',
      content: 'This solution helped the client to have a global website, with minimal downtime, DevOps based application code deployment and auto scaling to their website.'
    },
    {
      title: 'Cloud Advances',
      content: 'On top of that, our solution helped our client easily incorporate future cloud advances into its IT infrastructure and innovate at will in a highly competitive industry.'
    },
   
  ];
  toggleAccordion(index: number): void {
    this.isOpen[index] = !this.isOpen[index];
  }
}
